<template>

    <div class="page-content">
        <div data-height="130" class="page-title-bg bg-20"><!-- image --></div>
        <div data-height="130" class="page-title-bg dark-mode-tint"><!-- contrast for dark mode --></div>
        <div data-height="130" class="page-title-bg opacity-90 bg-highlight"><!-- background color --></div>

        <div class="page-title-small color-white bottom-30">
            <h1>Inicio</h1>
            <a href="#" data-menu="menu-main" class="shadow-huge scale-box bg-fade-gray2-dark"
                v-bind:style="userimageurl"></a>
            <span class="bg-highlight color-white">{{ username }}<br>{{ cargo }}</span>
        </div>

        <div class="content">

            <div>
                <a href="/BuscarOT" onclick="localStorage.setItem('datasearch', '');" data-height="180" class="caption round-medium shadow-large bg-theme bottom-15">
                    <div class="caption-center">
                        <h1 class="center-text">
                            <i data-feather="search" data-feather-line="1" data-feather-size="50"
                                data-feather-color="aqua-dark" data-feather-bg="aqua-fade-light">
                            </i>
                        </h1>
                        <h4 class="center-text color-theme">Buscar OT </h4>
                        <p class="under-heading color-highlight center-text font-11 color-highlight">
                            Busqueda de OT sobre ejecución
                        </p>
                    </div>
                    <div class="caption-bottom">
                        <p class="bottom-10 opacity-40 font-10 center-text">Ingrese aquí</p>
                    </div>
                </a>
            </div>

            <div>
                <a href="/OTAgenda" data-height="180" class="caption round-medium shadow-large bg-theme bottom-15">
                    <div class="caption-center">
                        <h1 class="center-text">
                            <i data-feather="calendar" data-feather-line="1" data-feather-size="50"
                                data-feather-color="magenta1-dark" data-feather-bg="magenta1-fade-light">
                            </i>
                        </h1>
                        <h4 class="center-text color-theme">OT Agenda </h4>
                        <p class="under-heading color-highlight center-text font-11 color-highlight">
                            Recepción de vehículos con hora reservada (Órdenes en proceso de mi sucursal)
                        </p>
                    </div>
                    <div class="caption-bottom">
                        <p class="bottom-10 opacity-40 font-10 center-text">Ingrese aquí</p>
                    </div>
                </a>
            </div>

            <div class="clear"></div>

            <div>
                <a href="/MisOT" data-height="180" class="caption round-medium shadow-large bg-theme bottom-15">
                    <div class="caption-center">
                        <h1 class="center-text">

                            <i data-feather="briefcase" data-feather-line="1" data-feather-size="50"
                                data-feather-color="orange-dark" data-feather-bg="orange-fade-light">
                            </i>
                        </h1>
                        <h4 class="center-text color-theme">Mis OTs</h4>
                        <p class="under-heading color-highlight center-text font-11 color-highlight">
                            Mis órdenes de trabajo en proceso (Mis OTs en etapa 2, 3, 4 )
                        </p>
                    </div>
                    <div class="caption-bottom">
                        <p class="bottom-10 opacity-40 font-10 center-text">Ingrese aquí</p>
                    </div>
                </a>
            </div>

            <div class="clear"></div>

            <div>
                <a href="/OTVencidas" data-height="180" class="caption round-medium shadow-large bg-theme bottom-15">
                    <div class="caption-center">
                        <h1 class="center-text">

                            <i data-feather="book-open" data-feather-line="1" data-feather-size="50"
                                data-feather-color="green1-dark" data-feather-bg="green1-fade-light">
                            </i>
                        </h1>
                        <h4 class="center-text color-theme">OTs Vencidas</h4>
                        <p class="under-heading color-highlight center-text font-11 color-highlight">
                            Clientes que no asistieron a su hora agendada
                        </p>
                    </div>
                    <div class="caption-bottom">
                        <p class="bottom-10 opacity-40 font-10 center-text">Ingrese aquí</p>
                    </div>
                </a>
            </div>



        </div>

    </div>

</template>

<script>

import axios from 'axios'
import * as db from "./../../database.js";

export default {

methods: {

    },
    
created(){
    this.username=JSON.parse(localStorage.getItem('user')).nombre
    this.cargo=JSON.parse(localStorage.getItem('user')).cargo

    this.userimageurl="background-image:url("+db.getServerHTTP()+JSON.parse(localStorage.getItem('user')).imageurl+")"

    }

}

</script>